import { isValid } from 'date-fns';

export const formatToISO = (date: Date | string): string => {
	if (typeof date === 'string' && date === '') return '';

	const d = typeof date === 'string' ? new Date(date) : date;

	if (!isValid(d)) return '';

	return d.toISOString();
};
